import api from '@/api';

const resource = 'merenda/movimento-deposito';

export default {
  criarMovimentoDeposito( data, header ) {
    return api.post( `${resource}`, data, header );
  },

  editarMovimentoDeposito( data ) {
    return api.put( `${resource}/${data.identificadortipomovimento}`, data);
  },

  deletarMovimentoDeposito( id ) {
    return api.delete(`${resource}/${id}`);
  },

  buscarMovimentosDeposito() {
    return api.get( `${resource}` );
  }
};
